import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning24 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "ugwy7byjca",
			width: "114.6%",
			height: "172.9%",
			x: "-7.3%",
			y: "-36.5%",
			filterUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("feOffset", {
					dy: 2,
					in: "SourceAlpha",
					result: "shadowOffsetOuter1"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					in: "shadowOffsetOuter1",
					result: "shadowBlurOuter1",
					stdDeviation: 8
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "shadowBlurOuter1",
					result: "shadowMatrixOuter1",
					values: "0 0 0 0 0.239215686 0 0 0 0 0.333333333 0 0 0 0 0.403921569 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsxs("feMerge", { children: [/* @__PURE__ */ _jsx("feMergeNode", { in: "shadowMatrixOuter1" }), /* @__PURE__ */ _jsx("feMergeNode", { in: "SourceGraphic" })] })
			]
		}) }),
		/* @__PURE__ */ _jsx("g", {
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
				filter: "url(#ugwy7byjca)",
				transform: "translate(-672 -1623) translate(652 1587) translate(0 24)",
				children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					fill: "#EB3785",
					d: "M21.767 18.317l-8.182-14.4C13.263 3.351 12.657 3 12 3c-.657 0-1.263.351-1.585.917l-8.182 14.4c-.316.558-.31 1.24.016 1.792S3.172 21 3.818 21h16.364c.646 0 1.243-.339 1.569-.891.326-.552.332-1.234.016-1.792z",
					transform: "translate(20 12)"
				}), /* @__PURE__ */ _jsx("path", {
					fill: "#000",
					d: "M12 16c.829 0 1.5.671 1.5 1.5S12.829 19 12 19s-1.5-.671-1.5-1.5.671-1.5 1.5-1.5zm0-8c.552 0 1 .448 1 1v5c0 .552-.448 1-1 1s-1-.448-1-1V9c0-.552.448-1 1-1z",
					transform: "translate(20 12)"
				})] })
			}) }) })
		})
	]
});
const ForwardRef = forwardRef(SvgWarning24);
export default ForwardRef;
